export const PERFORMANCE_DASHBOARD_DETAILS_REQUEST = 'PERFORMANCE_DASHBOARD_DETAILS_REQUEST';
export const PERFORMANCE_DASHBOARD_DETAILS_SUCCESS = 'PERFORMANCE_DASHBOARD_DETAILS_SUCCESS';
export const PERFORMANCE_DASHBOARD_DETAILS_ERROR = 'PERFORMANCE_DASHBOARD_DETAILS_ERROR';

// GPU Utilization
export const SET_GPU_UTILIZATION_REQUEST = 'SET_GPU_UTILIZATION_REQUEST';
export const SET_GPU_UTILIZATION_SUCCESS = 'SET_GPU_UTILIZATION_SUCCESS';
export const SET_GPU_UTILIZATION_ERROR = 'SET_GPU_UTILIZATION_ERROR' ;
export const SET_GPU_UTILIZATION_RESET = 'SET_GPU_UTILIZATION_RESET';

// GPU RAM memory usage
export const SET_GPU_RAM_MEMORY_USAGE_REQUEST = 'SET_GPU_RAM_MEMORY_USAGE_REQUEST';
export const SET_GPU_RAM_MEMORY_USAGE_SUCCESS = 'SET_GPU_RAM_MEMORY_USAGE_SUCCESS';
export const SET_GPU_RAM_MEMORY_USAGE_ERROR = 'SET_GPU_RAM_MEMORY_USAGE_ERROR';
export const SET_GPU_RAM_MEMORY_USAGE_RESET = 'SET_GPU_RAM_MEMORY_USAGE_RESET';

// GPU Available RAM memory
export const SET_GPU_AVAILABLE_RAM_MEMORY_REQUEST = 'SET_GPU_AVAILABLE_RAM_MEMORY_REQUEST';
export const SET_GPU_AVAILABLE_RAM_MEMORY_SUCCESS = 'SET_GPU_AVAILABLE_RAM_MEMORY_SUCCESS';
export const SET_GPU_AVAILABLE_RAM_MEMORY_ERROR = 'SET_GPU_AVAILABLE_RAM_MEMORY_ERROR';
export const SET_GPU_AVAILABLE_RAM_MEMORY_RESET = 'SET_GPU_AVAILABLE_RAM_MEMORY_RESET';

// CPU Utilization
export const SET_CPU_UTILIZATION_REQUEST = 'SET_CPU_UTILIZATION_REQUEST';
export const SET_CPU_UTILIZATION_SUCCESS = 'SET_CPU_UTILIZATION_SUCCESS';
export const SET_CPU_UTILIZATION_ERROR = 'SET_CPU_UTILIZATION_ERROR';
export const SET_CPU_UTILIZATION_RESET = 'SET_CPU_UTILIZATION_RESET';

// CPU Available RAM memory
export const SET_CPU_AVAILABLE_RAM_MEMORY_REQUEST = 'SET_CPU_AVAILABLE_RAM_MEMORY_REQUEST';
export const SET_CPU_AVAILABLE_RAM_MEMORY_SUCCESS = 'SET_CPU_AVAILABLE_RAM_MEMORY_SUCCESS';
export const SET_CPU_AVAILABLE_RAM_MEMORY_ERROR = 'SET_CPU_AVAILABLE_RAM_MEMORY_ERROR';
export const SET_CPU_AVAILABLE_RAM_MEMORY_RESET = 'SET_CPU_AVAILABLE_RAM_MEMORY_RESET';

// CPU RAM Memory Usage
export const SET_CPU_RAM_MEMORY_USAGE_REQUEST = 'SET_CPU_RAM_MEMORY_USAGE_REQUEST';
export const SET_CPU_RAM_MEMORY_USAGE_SUCCESS = 'SET_CPU_RAM_MEMORY_USAGE_SUCCESS';
export const SET_CPU_RAM_MEMORY_USAGE_ERROR = 'SET_CPU_RAM_MEMORY_USAGE_ERROR';
export const SET_CPU_RAM_MEMORY_USAGE_RESET = 'SET_CPU_RAM_MEMORY_USAGE_RESET';